import { Effect, Reducer } from '@umijs/max';
import { TramitType } from '@/interfaces/files';
import { getFilesCounters, getTramitTypes } from '@/services/files.service';

export interface ModelType {
  namespace: string;
  state: {
    tramitsTypes: TramitType[];
    counters: { total: number; affiliates: number; allowances: number } | null;
  };
  effects: {
    fetchData: Effect;
    fetchCountersData: Effect;
  };
  reducers: {
    setData: Reducer<any>;
  };
}

const Model: ModelType = {
  namespace: 'pendingFilesList',

  state: {
    counters: null,
    tramitsTypes: [],
  },

  effects: {
    *fetchData({ payload }, { call, put, all }) {
      const [tramitsTypes] = yield all([call(getTramitTypes, payload)]);
      yield put({
        type: 'setData',
        payload: {
          tramitsTypes: tramitsTypes.data,
        },
      });
    },

    *fetchCountersData({ payload }, { call, put, all }) {
      const [counters] = yield all([call(getFilesCounters, payload)]);
      yield put({
        type: 'setData',
        payload: {
          counters: counters.data,
        },
      });
    },
  },

  reducers: {
    setData(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};

export default Model;
